export class ModalRepository {
    protected modalTitleFrom: HTMLElement | null;
    protected modalDescriptionFrom: HTMLElement | null;
    protected modalContentFrom: HTMLElement | null;
    protected modalWidth: HTMLElement | null;
    protected modalHeight: HTMLElement | null;
    protected isModalCustom: HTMLElement | null;
    protected modalSize: HTMLElement | null;
    protected modalHeaderSize: HTMLElement | null;
    protected modalObjectSettings: HTMLElement | null;

    constructor(
        private container: HTMLElement
    ) {
        this.modalTitleFrom = container.querySelector('[data-modal-title-from]');
        this.modalDescriptionFrom = container.querySelector('[data-modal-description-from]');
        this.modalContentFrom = container.querySelector('[data-modal-content-from]');
        this.modalWidth = container.querySelector('[data-modal-width]');
        this.modalHeight = container.querySelector('[data-modal-height]');
        this.isModalCustom = container.querySelector('[data-is-modal-custom]');
        this.modalSize = container.querySelector('[data-modal-size-from]');
        this.modalHeaderSize = container.querySelector('[data-modal-header-size-from]');
        this.modalObjectSettings = container.querySelector('[data-modal-object-settings]');
    }
    getModalRepository() {
        return {
            modalTitleFrom: this.modalTitleFrom,
            modalDescriptionFrom: this.modalDescriptionFrom,
            modalContentFrom: this.modalContentFrom,
            modalWidth: this.modalWidth,
            modalHeight: this.modalHeight,
            isModalCustom: this.isModalCustom,
            modalSize: this.modalSize,
            modalHeaderSize: this.modalHeaderSize,
            modalObjectSettings: this.modalObjectSettings,
        }
    }
}
